import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";

import { AmssService } from "./amss.service";

@Injectable()
export class LookupService extends AmssService {

  constructor() {
      super();
  }

  public retrieveSymposiumForCurrentYear( apiUrl: string, year: number) {
    
    return this.getHttpService().GET(
      `${this.apiUrl}/symposium/year/${year}`,
      false
    );
  }

  public retrieveSalutationList() {
    return this.getHttpService().GET(
      `${this.apiUrl}/person/salutation/list/${this.symposium.guid}`,
      false
    );
  }

  public retrieveSuffixList() {
    return this.getHttpService().GET(
      `${this.apiUrl}/person/suffix/list/${this.symposium.guid}`,
      false
    );
  }

  public retrieveCountryList() {
    return this.getHttpService().GET(
      `${this.apiUrl}/country/list/${this.symposium.guid}`,
      false
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/lookup.service.ts